import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';

// Services
import Person from 'services/data/person';
import PhoneNumber from 'services/data/phone-number';

// Components
import SVG from 'components/widgets/icons/svg';


export default function AnswerOption({ call, answer }) {
  const { callStatus, userOnCall, lastUserOnCall, transferringTo } = call;
  const callIsAnswerable = _.isEmpty(userOnCall) && (callStatus === 'Incoming' || callStatus === 'Failed Transfer');

  return (
    <li
      onClick={callIsAnswerable ? () => answer(call) : _.noop}
      className={classNames('triage-option-answer', 'triage-option-header', { 'triage-action-complete': !callIsAnswerable })}
    >
      <SVG src="svg/answer.svg" className="triage-option-icon answer" />

      {/* If the call is incoming */}
      { callStatus === 'Incoming' &&
        'Answer'
      }
      {/* If the call is transferring */}
      { callStatus === 'Transferring' &&
        `Transferring Call to: ${Person.fullName(transferringTo)}`
      }
      {/* If the call failed to transfer */}
      { callStatus === 'Failed Transfer' &&
        <span>
          Answer Call
          <div className="triage-option-additional-info">
            { _.isEmpty(lastUserOnCall) ?
              'Answer by ' :
              `Transfer from ${Person.fullName(lastUserOnCall)} to `
            }
            {Person.fullName(transferringTo)} failed
          </div>
        </span>
      }
      {/* If the call is active, show the name of the person currently on the call */}
      { callStatus === 'Active' &&
        `Currently on Call: ${Person.fullName(userOnCall)}`
      }
      {/* If the call is not currently ongoing, offer the opportunity to call back */}
      { !_.includes(['Incoming', 'Active', 'Transferring', 'Failed Transfer'], callStatus) &&
        <span>
          <span>Call back at: </span>
          <a href={`tel:${call.from}`}>{PhoneNumber.format(call.from)}</a>
        </span>
      }
    </li>
  );
}

AnswerOption.propTypes = {
  call: PropTypes.object.isRequired,
  answer: PropTypes.func.isRequired
};
